import * as actions from 'appRedux/actions/taxInvoice/auditLogActionType';
import {
  TaxInvoiceLogItem,
  TaxInvoiceLogResponse,
  TaxInvoicePaging,
} from 'routes/main/taxInvoice/types';

export interface AuditLogState {
  loader: boolean;
  dataSource: TaxInvoiceLogItem[];
  paging: TaxInvoicePaging | null;
  error: string | null;
  process: {
    status: boolean;
    action: string;
    message: string;
  };
}

const initialState: AuditLogState = {
  loader: false,
  dataSource: [],
  paging: null,
  error: null,
  process: {
    status: false,
    action: '',
    message: '',
  },
};

export default (
  state: AuditLogState = initialState,
  action: actions.AuditLogAction
): AuditLogState => {
  switch (action.type) {
    case actions.TAX_INVOICE_LOG_REQUEST:
      return {
        ...state,
        loader: true,
        error: null,
        process: {
          status: false,
          action: 'taxInvoiceLogRequest',
          message: '',
        },
      };

    case actions.TAX_INVOICE_LOG_SUCCESS: {
      const response: TaxInvoiceLogResponse = action.payload;
      const resultData: any = response.data?.result_data;
      // Support both shapes: result_data.items[] and result_data[] (array)
      const items: TaxInvoiceLogItem[] = Array.isArray(resultData)
        ? resultData
        : resultData?.items || [];
      const paging: TaxInvoicePaging | null = Array.isArray(resultData)
        ? null
        : resultData?.paging || null;

      return {
        ...state,
        loader: false,
        dataSource: items,
        paging,
        error: null,
        process: {
          status: true,
          action: 'taxInvoiceLogRequest',
          message: response.data?.result_msg || 'Success',
        },
      };
    }

    case actions.TAX_INVOICE_LOG_ERROR:
      return {
        ...state,
        loader: false,
        error: action.payload.message,
        process: {
          status: false,
          action: 'taxInvoiceLogRequest',
          message: action.payload.message,
        },
      };

    case actions.TAX_INVOICE_LOG_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
